import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router-dom';

export type LinkAttributionSource = 'BUNDLE' | 'ORGANIZATION';

export type LinkAttributionRow = {
    rowKey: string;
    attributionGuid: string;
    displayName: string;
    type: string;
    source: LinkAttributionSource;
};

export const LINK_ATTRIBUTION_COLUMNS: GridColDef<LinkAttributionRow>[] = [
    {
        field: 'displayName',
        headerName: 'Name',
        flex: 2,
        minWidth: 200,
    },
    {
        field: 'type',
        headerName: 'Type',
        flex: 1,
        minWidth: 140,
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 100,
        sortable: false,
        renderCell: ({ row }) => (
            <Button
                component={RouterLink}
                to={`/attribution/${row.attributionGuid}`}
                size="small"
                variant="text"
                sx={{ textTransform: 'none' }}
            >
                Edit
            </Button>
        ),
    },
];
